import timg1 from '../images/team/yv-reddy.jpg'
import timg2 from '../images/team/srujana-madam.jpg'
import timg3 from '../images/team/asif.jpg'

import Stime1 from '../images/team-single/yv-reddy.jpg'
import Stime2 from '../images/team-single/srujana-madam.jpg'
import Stime3 from '../images/team-single/asif.jpg'

const commonAddress = `YV Reddy Associates,
Flat Bearing No. 501 and 502 on Fifth Floor,
THE RETREAT on Plots No. 68 and 69,
Guttala Begumpet Village,
Serilingampally Mandal, Madhapur,
Ranga Reddy District, Hyderabad - 500081`

const Teams = [
    {
        id: '1',
        title: 'Ar. Y. Veera Reddy',
        subtitle: 'Managing Director',
        slug: 'VEERA-REDDY-YANALA',
        timg: timg1,
        Sime: Stime1,

        position: 'Managing Director',
        practiceArea: 'Architect and Interior Design',
        experience: '25+ Years',
        address: commonAddress,
        phone: '+91 7331149267',
        email: 'yvreddyassociates.com@gmail.com',

        professionalInfo: [
            "Ar. Y. Veera Reddy is the Managing Director and Chief Architect of YV Reddy Associates with over 25 years of professional experience in architectural and interior design consultancy.",
            "He leads the firm with a strong focus on architectural planning, interior design execution, and overall project coordination, ensuring design intent is carried through to completion.",
            "His leadership has guided the successful delivery of residential, commercial, and community-oriented projects with emphasis on functionality, clarity, and execution quality."
        ],

        skills: [
            { name: 'Architectural Design & Planning', value: '95%' },
            { name: 'Interior Design Execution', value: '90%' },
            { name: 'Project Leadership', value: '95%' },
            { name: 'Client & Team Coordination', value: '90%' }
        ]
    },
    {
        id: '2',
        title: 'Mrs. Y. Srujana',
        subtitle: 'Director',
        slug: 'Srujana',
        timg: timg2,
        Sime: Stime2,

        position: 'Director',
        practiceArea: 'Interior Design and Administration',
        experience: '10+ Years',
        address: commonAddress,
        phone: '+91 7331149267',
        email: 'yvreddyassociates.com@gmail.com',

        professionalInfo: [
            "Mrs. Y. Srujana serves as the Director at YV Reddy Associates, bringing over 10 years of experience in interior design consultancy and administrative management.",
            "She plays a key role in overseeing interior design execution, coordinating teams, and managing administrative operations within the organization.",
            "Her contribution ensures smooth project workflows, quality control, and effective coordination between clients, designers, and execution teams."
        ],

        skills: [
            { name: 'Interior Design Planning', value: '90%' },
            { name: 'Administrative Management', value: '85%' },
            { name: 'Client Coordination', value: '88%' },
            { name: 'Project Supervision', value: '85%' }
        ]
    },
    {
        id: '3',
        title: 'Mr. A. Asif Pasha',
        subtitle: 'Executive Director',
        slug: 'Asif-Pasha',
        timg: timg3,
        Sime: Stime3,

        position: 'Executive Director',
        practiceArea: 'Marketing and Interior Design',
        experience: '30+ Years',
        address: commonAddress,
        phone: '+91 7331149267',
        email: 'yvreddyassociates.com@gmail.com',

        professionalInfo: [
            "Mr. A. Asif Pasha is the Executive Director at YV Reddy Associates with over 30 years of diverse professional experience in marketing and interior design consultancy.",
            "He is responsible for business development, marketing strategy, and client relationship management, supporting the firm’s growth and market presence.",
            "His extensive experience strengthens the firm’s ability to align design services with client expectations and industry trends."
        ],

        skills: [
            { name: 'Marketing Strategy', value: '90%' },
            { name: 'Client Relations', value: '92%' },
            { name: 'Interior Project Coordination', value: '85%' },
            { name: 'Business Development', value: '88%' }
        ]
    }
]

export default Teams
